import Vue from 'vue'
import Vuex from 'vuex'

import authStore from './auth.store'
import tripStore from './trip.store'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    authStore,
    tripStore
  }
})
